// src/components/ui/InputForm.jsx
import "./InputForm.css";
import { useMessages } from "../../context/MessageContext";

function Input({
  label,
  name,
  type = "text",
  placeholder,
  value,
  onChange,
  required = false,
  options = [],
  readOnly = false,
  disabled = false,
  copyable = false,

  leftIcon,
  onLeftIconClick,
  rightIcon,  
  onRightIconClick,   

  labelHelpIcon,
  onLabelHelpClick,
  inputClassName = "",
  wrapperClassName = "",

  noLabel = false, 
  multiple = false,
}) {
  const { addMessage } = useMessages();

  const handleCopy = () => {
    if (value) {
      navigator.clipboard.writeText(value);
      addMessage("Gekopieerd!", "success");
    }
  };
  const copyIcon = "/icons/copy.png";

  const commonProps = {
    id: name,
    name,
    value,
    onChange,
    required,
    readOnly,
    disabled,
    placeholder,
    className: `form-input ${leftIcon ? "has-left-icon" : ""} ${inputClassName}`,
  };

  return (
    <div className={`form-group ${wrapperClassName} ${noLabel ? "no-label" : ""}`}>
      {!noLabel && label && (   // 👈 conditionally render label
        <label htmlFor={name} className="form-label">
          <span>{label}</span>
          {labelHelpIcon && (
            <img
              src={labelHelpIcon}
              alt="help"
              className="form-label-help"
              onClick={onLabelHelpClick}
            />
          )}
        </label>
      )}

      <div className="input-wrapper">
        {leftIcon && (
          <button
            type="button"
            className="left-icon-btn"
            onClick={onLeftIconClick}
            aria-label="icon"
            tabIndex={-1}
          >
            <img src={leftIcon} alt="" />
          </button>
        )}

        {type === "select" ? (
          <select
            {...commonProps}
            multiple={multiple}
            value={
              multiple
                ? Array.isArray(value)
                  ? value.map(String)
                  : value
                    ? [String(value)]
                    : []
                : value
            }
            className={`form-select ${leftIcon ? "has-left-icon" : ""} ${inputClassName}`}
          >
            {!multiple && (
              <option value="">{placeholder || "Selecteer een optie"}</option>
            )}
            {options.map((opt, i) => {
              const rawValue =
                typeof opt === "string" || typeof opt === "number"
                  ? opt
                  : opt?.value ?? "";
              const rawLabel =
                typeof opt === "string" || typeof opt === "number"
                  ? opt
                  : opt?.label ?? opt?.value ?? "";
              const optionValue = rawValue === undefined || rawValue === null ? "" : String(rawValue);
              const optionLabel = rawLabel === undefined || rawLabel === null ? "" : String(rawLabel);

              return (
                <option key={`${optionValue}-${i}`} value={optionValue}>
                  {optionLabel}
                </option>
              );
            })}
          </select>
        ) : type === "textarea" ? (
          <textarea
            {...commonProps}
            className={`form-textarea ${leftIcon ? "has-left-icon" : ""} ${inputClassName}`}
            rows={5}
          />
        ) : (
          <input type={type} {...commonProps} />
        )}
        
        {rightIcon && (
          <button
            type="button"
            className="right-icon-btn"
            onClick={onRightIconClick}
            tabIndex={-1}
          >
            <img src={rightIcon} alt="" />
          </button>
        )}

        {copyable && (
          <button type="button" className="copy-btn" onClick={handleCopy} aria-label="Kopieer">
            <img src={copyIcon} alt="copy" />
          </button>
        )}

        
      </div>
    </div>
  );
}

export default Input;
